class Industry {
  constructor(_id, id, name, imageURL, individuals, location, favoriteCount) {
    this._id = _id;
    this.id = id;
    this.name = name;
    this.imageURL = imageURL;
    this.individuals = individuals;
    this.location = location;
    this.favoriteCount = favoriteCount ?? 0;
  }
}

module.exports = Industry;
